import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";

const LINKS = [
  { name: "Home", href: "#home", testid: "nav-link-home" },
  { name: "About", href: "#about", testid: "nav-link-about" },
  { name: "Barbers", href: "#barbers", testid: "nav-link-barbers" },
  { name: "Services", href: "#services", testid: "nav-link-services" },
  { name: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-obsidian-900/85 backdrop-blur-xl border-b border-gold/20" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 lg:px-8">
        <button onClick={() => go("#home")} data-testid="nav-logo-button" className="cursor-pointer">
          <Logo />
        </button>

        <div className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.name}
              data-testid={l.testid}
              onClick={() => go(l.href)}
              className="text-sm font-medium text-gray-300 transition-colors duration-200 hover:text-gold"
            >
              {l.name}
            </button>
          ))}
          <Link
            to="/admin"
            data-testid="nav-link-admin"
            className="text-sm font-medium text-gray-500 transition-colors duration-200 hover:text-gold"
          >
            Admin
          </Link>
          <button
            data-testid="nav-cta-book"
            onClick={() => go("#booking")}
            className="rounded-full bg-gold px-6 py-2.5 text-sm font-bold text-obsidian-900 transition-colors duration-200 hover:bg-gold-hover"
          >
            Book Appointment
          </button>
        </div>

        <button
          className="lg:hidden text-gold"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-gold/20 bg-obsidian-900/95 backdrop-blur-xl lg:hidden" data-testid="mobile-menu">
          <div className="flex flex-col gap-1 px-5 py-4">
            {LINKS.map((l) => (
              <button
                key={l.name}
                data-testid={`mobile-${l.testid}`}
                onClick={() => go(l.href)}
                className="py-3 text-left text-base font-medium text-gray-200 hover:text-gold"
              >
                {l.name}
              </button>
            ))}
            <Link
              to="/admin"
              onClick={() => setOpen(false)}
              className="py-3 text-left text-base font-medium text-gray-500 hover:text-gold"
              data-testid="mobile-nav-link-admin"
            >
              Admin
            </Link>
            <button
              data-testid="mobile-nav-cta-book"
              onClick={() => go("#booking")}
              className="mt-2 rounded-full bg-gold px-6 py-3 text-center text-base font-bold text-obsidian-900"
            >
              Book Appointment
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
